import { createApiRequest } from "../common";
import { UpdateOrgThemeRequestContent, UpdateOrgThemeResponseContent } from '@equaliq/api-model-v2';

export const updateOrgThemeApi = async (request: UpdateOrgThemeRequestContent): Promise<UpdateOrgThemeResponseContent> => {
  const apiRequest = createApiRequest<UpdateOrgThemeResponseContent>('post', '/orgs/updateOrgTheme');
  return apiRequest(request);
};
